/**
 * ACC_ThrivinUK_CartDrawer_33 — THEME asset (V1 + V2)
 *
 *
 * Control: no class → theme native.
 * V1 body class: ACC_ThrivinUK_CartDrawer_33
 *   → £80 / £100 / £120 / £140 · clear cart attr
 * V2 body class: ACC_ThrivinUK_CartDrawer_33_v2
 *   → £90 / £110 / £130 / £150 · set _acc_thrivinuk_cartdrawer_33 = "2"
 *
 * ─────────────────────────────────────────────────────────────
 * REQUIRED in custom.js — same hooks; active() covers V1 + V2.
 * ─────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  var TEST_CLASS = 'ACC_ThrivinUK_CartDrawer_33';
  var TEST_CLASS_V2 = 'ACC_ThrivinUK_CartDrawer_33_v2';
  var CART_ATTR = '_acc_thrivinuk_cartdrawer_33';
  var SOCKS_FLAG = '__freeGiftRemovedInSession';
  var SOCKS_GATE = '__acc33_socksGate';
  var DISMISS_PREFIX = '__acc33_gift_dismissed_';
  var syncing = false;
  var wired = false;
  var drawerRefreshPending = false;
  var lastSpent = null;
  var themeOpenFreeGiftPopup = null;
  var themeRenderFreeGiftPopup = null;
  var barMo = null;
  var cartAttrSyncing = false;

  var BAR_INSET = 15;
  var GIFT_HANDLES = {
    gift1: ['headband-night-black'],
    gift2: ['free-thrivin-silk-socks-white', 'our-gift-for-you-free-white-silk-socks'],
    gift3: ['cap-dark-mauve', 'cap-cream'],
  };
  var SOCKS_HANDLES = ['our-gift-for-you-free-white-silk-socks', 'free-thrivin-silk-socks-white'];

  function hasClass(name) {
    return (
      document.documentElement.classList.contains(name) ||
      (document.body && document.body.classList.contains(name))
    );
  }

  /* 2 = V2, 1 = V1, 0 = off (V2 checked first) */
  function getVersion() {
    if (hasClass(TEST_CLASS_V2)) return 2;
    if (hasClass(TEST_CLASS)) return 1;
    return 0;
  }

  function isActive() {
    return getVersion() > 0;
  }

  function getBarTiers() {
    var bump = getVersion() === 2 ? 10 : 0;
    return [
      { key: 'shipping', goal: 80 + bump, label: 'Free shipping', icon: 'truck' },
      { key: 'socks', goal: 100 + bump, label: 'Free socks', icon: 'sock' },
      { key: 'gift', goal: 120 + bump, label: 'Free gift', icon: 'gift', milestoneKey: 'gift1' },
      { key: 'item', goal: 140 + bump, label: 'Free item', icon: 'star', milestoneKey: 'gift3' },
    ];
  }

  function getGiftMilestones() {
    var tiers = getBarTiers();
    return [
      { key: 'gift1', goal: tiers[2].goal },
      { key: 'gift3', goal: tiers[3].goal },
    ];
  }

  function minGiftGoal() {
    return getGiftMilestones()[0].goal;
  }

  function socksGoal() {
    return getBarTiers()[1].goal;
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getSpent(cart) {
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return Number(cart && cart.total_price ? cart.total_price : 0) / 100 / rate;
  }

  function formatMoney(amount) {
    var x = Math.max(0, Number(amount) || 0);
    var fixed = x.toFixed(2);
    var neat = fixed.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var symbol = code === 'GBP' ? '£' : code + ' ';
    return symbol + neat;
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js?v=' + Date.now(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  /* V2 → "2" (raised shipping in checkout); V1 → "" (clear V2 mark) */
  async function syncCartAttribute() {
    if (!isActive() || cartAttrSyncing) return;
    var desired = getVersion() === 2 ? '2' : '';
    cartAttrSyncing = true;
    try {
      var cart = await fetchCart();
      var attrs = (cart && cart.attributes) || {};
      if (String(attrs[CART_ATTR] == null ? '' : attrs[CART_ATTR]) === desired) return;
      await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [CART_ATTR]: desired } }),
      });
    } catch (e) {
      console.error('[ACC33] cart attribute', e);
    } finally {
      cartAttrSyncing = false;
    }
  }

  function refreshCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function removeLine(key) {
    if (!key) return Promise.resolve(null);
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (r) {
      return r.json();
    });
  }

  function propTrue(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function itemHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    var url = item.url || '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function isZeroPriceLine(item) {
    if (!item) return false;
    var final = Number(item.final_line_price);
    var line = Number(item.line_price);
    if (!isNaN(final)) return final === 0;
    if (!isNaN(line)) return line === 0;
    return false;
  }

  function getSocksGiftVariantIds() {
    var block = document.querySelector('[data-free-gift-auto]');
    if (!block) return [];
    try {
      return JSON.parse(block.dataset.giftVariantIds || '[]').map(String);
    } catch (e) {
      return [];
    }
  }

  function isSocksGiftLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (propTrue(props._free_gift_socks)) return true;
    if (!isZeroPriceLine(item)) return false;

    var variantIds = getSocksGiftVariantIds();
    if (variantIds.length && variantIds.indexOf(String(item.variant_id)) !== -1) return true;

    return SOCKS_HANDLES.indexOf(itemHandle(item)) !== -1;
  }

  function findPopupGift(cart, milestoneKey) {
    if (!cart || !cart.items) return null;
    var handles = GIFT_HANDLES[milestoneKey] || [];
    return cart.items.find(function (item) {
      var props = item.properties || {};
      if (propTrue(props._free_gift) && props._milestone === milestoneKey) return true;
      if (milestoneKey === 'gift2') return false;
      if (!handles.length || !isZeroPriceLine(item)) return false;
      return handles.indexOf(itemHandle(item)) !== -1;
    });
  }

  function findSocksLine(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.find(isSocksGiftLine);
  }

  function dismissKey(key) {
    return DISMISS_PREFIX + key;
  }

  function isDismissed(key) {
    return sessionStorage.getItem(dismissKey(key)) === '1';
  }

  function markDismissed(key) {
    if (key) sessionStorage.setItem(dismissKey(key), '1');
  }

  function resetDismissBelow(spent) {
    getGiftMilestones().forEach(function (m) {
      if (spent >= m.goal) return;
      sessionStorage.removeItem(dismissKey(m.key));
    });
  }

  function giftRule(key) {
    return getGiftMilestones().find(function (m) {
      return m.key === key;
    });
  }

  function isGiftEligible(key, spent) {
    var rule = giftRule(key);
    if (!rule) return false;
    if (spent == null || spent < rule.goal) return false;
    if (isDismissed(key)) return false;
    return true;
  }

  function closeGiftPopup() {
    document.querySelectorAll('#free-gift-popup').forEach(function (popup) {
      popup.classList.remove('show');
    });
  }

  function isGiftPopupOpen(key) {
    var open = false;
    document.querySelectorAll('#free-gift-popup.show').forEach(function () {
      open = true;
    });
    if (!open) return false;
    if (!key) return true;
    return window.activeMilestoneKey === key;
  }

  /* Hard close when below ACC gift threshold (kills native £80 flash) */
  function enforcePopupGate(spent) {
    if (spent != null) lastSpent = spent;
    var useSpent = spent != null ? spent : lastSpent;
    if (useSpent == null || useSpent < minGiftGoal()) {
      closeGiftPopup();
      return;
    }
    var key = window.activeMilestoneKey;
    if (key && !isGiftEligible(key, useSpent)) closeGiftPopup();
  }

  function markerPos(index) {
    var n = getBarTiers().length;
    if (n <= 1) return 50;
    return BAR_INSET + (index / (n - 1)) * (100 - 2 * BAR_INSET);
  }

  function calculateProgress(spent) {
    var tiers = getBarTiers();
    var last = tiers[tiers.length - 1];
    if (spent > last.goal) return 100;

    var first = tiers[0];
    if (spent <= 0) return 0;
    if (spent < first.goal) {
      return (spent / first.goal) * markerPos(0);
    }

    for (var i = 1; i < tiers.length; i++) {
      var goal = tiers[i].goal;
      var prev = tiers[i - 1].goal;
      if (spent <= goal) {
        var from = markerPos(i - 1);
        var to = markerPos(i);
        return from + ((spent - prev) / (goal - prev)) * (to - from);
      }
    }

    return markerPos(tiers.length - 1);
  }

  function ensureBar(container) {
    if (!container) return;
    var ver = String(getVersion());
    var existing = container.querySelector('.' + TEST_CLASS + '_track');
    if (existing) {
      if (existing.getAttribute('data-acc33-v') === ver) return;
      existing.remove();
    }
    var line = container.querySelector('.milestone-line');
    if (!line) return;

    var tiers = getBarTiers();
    var html = tiers
      .map(function (tier, i) {
        var pos = markerPos(i);
        return (
          '<div class="' +
          TEST_CLASS +
          '_milestone" data-tier="' +
          tier.key +
          '" style="--acc33-pos:' +
          pos +
          '%">' +
          '<div class="' +
          TEST_CLASS +
          '_meta">' +
          '<span class="' +
          TEST_CLASS +
          '_icon ' +
          TEST_CLASS +
          '_icon_' +
          tier.icon +
          '" aria-hidden="true"></span>' +
          '<span class="' +
          TEST_CLASS +
          '_label">' +
          tier.label +
          '</span>' +
          '</div>' +
          '<div class="' +
          TEST_CLASS +
          '_dot"></div>' +
          '<span class="' +
          TEST_CLASS +
          '_goal">' +
          formatMoney(tier.goal) +
          '</span>' +
          '</div>'
        );
      })
      .join('');

    line.insertAdjacentHTML(
      'beforeend',
      '<div class="' + TEST_CLASS + '_track" data-acc33-v="' + ver + '">' + html + '</div>'
    );

    var message = container.querySelector('.milestone-message');
    if (message && !message.querySelector('.' + TEST_CLASS + '_current')) {
      message.insertAdjacentHTML('beforeend', '<span class="' + TEST_CLASS + '_current"></span>');
    }
  }

  function renderBar(spent) {
    if (spent == null || isNaN(spent)) return;
    lastSpent = spent;

    var container = document.querySelector('.milestone-container');
    if (!container) return;
    ensureBar(container);

    var tiers = getBarTiers();
    var banner = document.getElementById('free-shipping-banner');
    var currentEl = container.querySelector('.' + TEST_CLASS + '_current');
    var next = tiers.find(function (t) {
      return spent < t.goal;
    });

    if (banner) {
      banner.innerHTML = next
        ? 'Only <b>' + formatMoney(next.goal - spent) + ' more</b> for ' + next.label
        : '<b>All rewards unlocked</b>';
    }
    if (currentEl) {
      currentEl.innerHTML = 'Current value <b>' + formatMoney(spent) + '</b>';
    }

    var inner = container.querySelector('.milestone-line-inner');
    if (inner) inner.style.setProperty('--progress', calculateProgress(spent) + '%');

    container.querySelectorAll('.' + TEST_CLASS + '_milestone').forEach(function (el, i) {
      var tier = tiers.find(function (t) {
        return t.key === el.dataset.tier;
      });
      var idx = tier ? tiers.indexOf(tier) : i;
      el.style.setProperty('--acc33-pos', markerPos(idx) + '%');
      el.classList.toggle(TEST_CLASS + '_reached', !!(tier && spent >= tier.goal));
    });
  }

  /* Sync — theme wiped drawer HTML; put bar back before paint settles */
  function rehydrateBar() {
    if (!isActive()) return;
    if (lastSpent == null) return;
    renderBar(lastSpent);
    enforcePopupGate(lastSpent);
  }

  async function syncSocks(cart, spent) {
    var goal = socksGoal();
    var current = cart;
    var removed = false;

    if (spent < goal) {
      sessionStorage.setItem(SOCKS_FLAG, '1');
      sessionStorage.setItem(SOCKS_GATE, '1');
      var toast = document.querySelector('.free-gift-toast');
      if (toast) toast.remove();
      var line = findSocksLine(current);
      while (line && line.key) {
        var next = await removeLine(line.key);
        if (!next) break;
        current = next;
        removed = true;
        line = findSocksLine(current);
      }
      current.__acc33Dirty = current.__acc33Dirty || removed;
      return current;
    }

    if (sessionStorage.getItem(SOCKS_GATE) === '1') {
      sessionStorage.removeItem(SOCKS_GATE);
      sessionStorage.removeItem(SOCKS_FLAG);
      current.__acc33NeedSocksInit = true;
    }
    return current;
  }

  async function removeInvalidPopupGifts(cart, spent) {
    var current = cart;
    var removed = false;

    var gift2 = findPopupGift(current, 'gift2');
    while (gift2 && gift2.key) {
      var after2 = await removeLine(gift2.key);
      if (!after2) break;
      current = after2;
      removed = true;
      gift2 = findPopupGift(current, 'gift2');
    }

    var gifts = getGiftMilestones();
    for (var i = 0; i < gifts.length; i++) {
      var m = gifts[i];
      if (spent >= m.goal) continue;
      var gift = findPopupGift(current, m.key);
      while (gift && gift.key) {
        var next = await removeLine(gift.key);
        if (!next) break;
        current = next;
        removed = true;
        gift = findPopupGift(current, m.key);
      }
    }
    current.__acc33Dirty = current.__acc33Dirty || removed;
    return current;
  }

  function patchThemeGiftFns() {
    if (typeof window.openFreeGiftPopup === 'function' && !window.openFreeGiftPopup.__acc33Patched) {
      themeOpenFreeGiftPopup = window.openFreeGiftPopup;
      var gatedOpen = function (key, cart) {
        if (isActive()) {
          var spent = cart ? getSpent(cart) : lastSpent;
          if (!isGiftEligible(key, spent)) return;
        }
        return themeOpenFreeGiftPopup.call(this, key, cart);
      };
      gatedOpen.__acc33Patched = true;
      window.openFreeGiftPopup = gatedOpen;
    }

    if (typeof window.renderFreeGiftPopup === 'function' && !window.renderFreeGiftPopup.__acc33Patched) {
      themeRenderFreeGiftPopup = window.renderFreeGiftPopup;
      var gatedRender = function (key, cart) {
        if (isActive()) {
          var spent = cart ? getSpent(cart) : lastSpent;
          if (!isGiftEligible(key, spent)) return;
        }
        return themeRenderFreeGiftPopup.call(this, key, cart);
      };
      gatedRender.__acc33Patched = true;
      window.renderFreeGiftPopup = gatedRender;
    }
  }

  function maybeOfferGift(cart, spent) {
    if (drawerRefreshPending) return;

    var pending = getGiftMilestones().find(function (m) {
      return isGiftEligible(m.key, spent) && !findPopupGift(cart, m.key);
    });
    if (!pending) return;
    if (isGiftPopupOpen(pending.key)) return;

    window.activeMilestoneKey = pending.key;

    if (typeof window.renderFreeGiftPopup === 'function') {
      window.renderFreeGiftPopup(pending.key, cart);
      return;
    }
    if (typeof window.openFreeGiftPopup === 'function') {
      window.openFreeGiftPopup(pending.key, cart);
    }
  }

  async function suppressStaleGiftPopup() {
    if (!isActive()) return;
    try {
      var cart = await fetchCart();
      var spent = getSpent(cart);
      lastSpent = spent;
      enforcePopupGate(spent);
    } catch (e) {
      closeGiftPopup();
    }
  }

  function watchPopupNode(popup) {
    if (!popup || popup.__acc33Watched) return;
    popup.__acc33Watched = true;
    var mo = new MutationObserver(function () {
      if (!isActive()) return;
      if (!popup.classList.contains('show')) return;
      var spent = lastSpent;
      if (spent == null || spent < minGiftGoal()) {
        popup.classList.remove('show');
        return;
      }
      var key = window.activeMilestoneKey;
      if (key && !isGiftEligible(key, spent)) popup.classList.remove('show');
    });
    mo.observe(popup, { attributes: true, attributeFilter: ['class'] });
  }

  function watchAllPopups() {
    document.querySelectorAll('#free-gift-popup').forEach(watchPopupNode);
  }

  function bindBarPersist() {
    if (barMo) return;
    barMo = new MutationObserver(function () {
      if (!isActive()) return;
      watchAllPopups();
      var container = document.querySelector('.milestone-container');
      if (!container) return;
      if (!container.querySelector('.' + TEST_CLASS + '_track') && lastSpent != null) {
        rehydrateBar();
      }
      /* Popup gained .show while below threshold */
      enforcePopupGate(lastSpent);
    });
    barMo.observe(document.documentElement, { childList: true, subtree: true });
  }

  async function takeover() {
    if (!isActive()) return;
    if (syncing) return;
    syncing = true;
    var dirty = false;
    var needSocksInit = false;
    try {
      patchThemeGiftFns();
      syncCartAttribute();
      rehydrateBar();

      var cart = await fetchCart();
      var spent = getSpent(cart);
      lastSpent = spent;
      resetDismissBelow(spent);
      enforcePopupGate(spent);
      renderBar(spent);

      var container = document.querySelector('.milestone-container');
      var banner = document.getElementById('free-shipping-banner');
      if (!banner && !container) return;

      if (typeof window.CURRENT_CART !== 'undefined') {
        try {
          window.CURRENT_CART = cart;
        } catch (e) {
          /* ignore */
        }
      }

      if (banner) banner.dataset.total = String(cart.total_price != null ? cart.total_price : '');

      cart = await syncSocks(cart, spent);
      dirty = dirty || !!cart.__acc33Dirty;
      needSocksInit = needSocksInit || !!cart.__acc33NeedSocksInit;
      spent = getSpent(cart);
      cart = await removeInvalidPopupGifts(cart, spent);
      dirty = dirty || !!cart.__acc33Dirty;
      spent = getSpent(cart);

      cart = await syncSocks(cart, spent);
      dirty = dirty || !!cart.__acc33Dirty;
      needSocksInit = needSocksInit || !!cart.__acc33NeedSocksInit;
      spent = getSpent(cart);
      cart = await removeInvalidPopupGifts(cart, spent);
      dirty = dirty || !!cart.__acc33Dirty;
      spent = getSpent(cart);
      lastSpent = spent;

      if (typeof window.CURRENT_CART !== 'undefined') {
        try {
          window.CURRENT_CART = cart;
        } catch (e2) {
          /* ignore */
        }
      }
      if (banner) banner.dataset.total = String(cart.total_price != null ? cart.total_price : '');

      resetDismissBelow(spent);
      renderBar(spent);
      enforcePopupGate(spent);

      /*
       * Avoid extra cart:refresh when possible — it wipes the bar again (~1s flicker).
       * Socks init may emit its own cart:change (one theme replace). Silent removes:
       * refresh only if we actually removed lines AND socks init won't refresh for us.
       */
      if (needSocksInit && typeof window.__freeGiftAutoInit === 'function') {
        drawerRefreshPending = true;
        window.__freeGiftAutoInit();
        window.setTimeout(function () {
          if (!isActive() || !drawerRefreshPending) return;
          drawerRefreshPending = false;
          /* No second full refresh — next takeover only updates numbers */
          takeover();
        }, 500);
        return;
      }

      if (dirty) {
        /* One section refresh so removed gift/socks lines leave the drawer */
        drawerRefreshPending = true;
        refreshCartDrawer();
        return;
      }

      maybeOfferGift(cart, spent);
    } catch (e) {
      console.error('[ACC33]', e);
    } finally {
      syncing = false;
    }
  }

  function bindDismiss() {
    if (wired) return;
    wired = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!isActive()) return;
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (!t.closest('#close-free-gift')) return;
        markDismissed(window.activeMilestoneKey);
        closeGiftPopup();
      },
      true
    );

    /* Capture: rehydrate bar + kill stale popup BEFORE handleMilestones */
    document.addEventListener(
      'cart-drawer:refreshed',
      function () {
        drawerRefreshPending = false;
        if (!isActive()) return;
        rehydrateBar();
        suppressStaleGiftPopup();
      },
      true
    );

    /* Opening drawer without section replace — still kill native gift flash */
    document.addEventListener(
      'click',
      function (e) {
        if (!isActive()) return;
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (!t.closest('[aria-controls="cart-drawer"], [href="/cart"], cart-drawer, #cart-drawer')) return;
        window.setTimeout(function () {
          rehydrateBar();
          enforcePopupGate(lastSpent);
          suppressStaleGiftPopup();
        }, 0);
      },
      true
    );

    var tries = 0;
    var patchTimer = window.setInterval(function () {
      patchThemeGiftFns();
      watchAllPopups();
      if (
        window.openFreeGiftPopup &&
        window.openFreeGiftPopup.__acc33Patched &&
        window.renderFreeGiftPopup &&
        window.renderFreeGiftPopup.__acc33Patched
      ) {
        window.clearInterval(patchTimer);
        return;
      }
      if (++tries > 40) window.clearInterval(patchTimer);
    }, 250);
  }

  function boot() {
    window.__ACC33 = {
      takeover: takeover,
      active: isActive,
      version: getVersion,
      socksPaused: function () {
        if (!isActive()) return false;
        return true;
      },
      get socksGoal() {
        return socksGoal();
      },
    };

    bindDismiss();
    bindBarPersist();
    patchThemeGiftFns();
    watchAllPopups();

    if (!isActive()) {
      var mo = new MutationObserver(function () {
        if (!isActive()) return;
        mo.disconnect();
        syncCartAttribute();
        rehydrateBar();
        suppressStaleGiftPopup();
        takeover();
      });
      mo.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
      return;
    }

    syncCartAttribute();
    suppressStaleGiftPopup();
    takeover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
